import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SimpleSnackBar } from './simple-snack-bar';
import { NdtSnackBarContainer } from './snack-bar-container';
import { NdtSnackBarAction, NdtSnackBarActions, NdtSnackBarLabel } from './snack-bar-content';

@NgModule({
  imports: [OverlayModule, PortalModule, CommonModule],
  exports: [NdtSnackBarContainer, NdtSnackBarLabel, NdtSnackBarActions, NdtSnackBarAction],
  declarations: [SimpleSnackBar, NdtSnackBarContainer, NdtSnackBarLabel, NdtSnackBarActions, NdtSnackBarAction],
})
export class NdtSnackBarModule {}
